var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-buildify-aspect-ratio-picker.ts
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/fonts/fonts.js";
import { FormField } from "@adornis/formfield/form-field.js";
import "@adornis/forms/x-input.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
var XBuildifyAspectRatioPicker = class extends FormField {
  splitAspectRatioString() {
    const splitStr = this.value.value?.split("/").map((x) => x.trim()) ?? [];
    return { width: splitStr[0] ? +splitStr[0] : null, height: splitStr[1] ? +splitStr[1] : null };
  }
  render() {
    const aspectRatio = this.splitAspectRatioString();
    return html`
      <x-flex space="xs">
        <x-text tone="subtle"> Seitenverhältnis </x-text>
        <x-flex horizontal space="xs" crossaxis-center>
          <x-input
            flex
            type="number"
            placeholder="Breite"
            @value-picked=${(e) => {
      this._commitValue({ height: aspectRatio.height, width: e.detail.value });
    }}
            .value=${aspectRatio.width}
          ></x-input>
          <x-text> / </x-text>
          <x-input
            flex
            type="number"
            placeholder="Höhe"
            @value-picked=${(e) => {
      this._commitValue({ width: aspectRatio.width, height: e.detail.value });
    }}
            .value=${aspectRatio.height}
          ></x-input>
        </x-flex>
      </x-flex>
    `;
  }
  _commitValue(aspectRatioObj) {
    if (!aspectRatioObj)
      this.value.next(null);
    else
      this.value.next(`${aspectRatioObj.width ?? ""} / ${aspectRatioObj.height ?? ""}`);
    this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
  }
};
XBuildifyAspectRatioPicker = __decorateClass([
  customElement("x-buildify-aspect-ratio-picker")
], XBuildifyAspectRatioPicker);
export {
  XBuildifyAspectRatioPicker
};
